import { User } from 'firebase/auth'

export interface AuthenticateResult {
  ok: boolean
  data?: any
  error?: string
}

export async function authenticateWithBackend(user: User): Promise<AuthenticateResult> {
  try {
    // Get Firebase ID token
    const idToken = await user.getIdToken()
    
    const response = await fetch(`${import.meta.env.VITE_API_BASE_URL || ''}login_firebase`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      },
      body: JSON.stringify({
        email: user.email,
        displayName: user.displayName,
        photoURL: user.photoURL,
        uid: user.uid
      }),
      credentials: 'include'
    })

    const data = await response.json()
    
    // Handle specific error cases
    if (response.status === 403) {
      return { ok: false, data, error: data?.error || 'Access denied' }
    }
    
    if (data?.status) {
      try {
        if (typeof data.session !== 'undefined') {
          document.cookie = `session=${encodeURIComponent(data.session)}; path=/;`
        }
        document.cookie = `aira_status=${encodeURIComponent(String(data.status))}; path=/;`
      } catch {}
      return { ok: true, data }
    }
    return { ok: false, data, error: data?.error || 'Unauthorized' }
  } catch (err: any) {
    return { ok: false, error: err?.message || 'Network error' }
  }
}


